function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "trello_ico-a",
  x1: "50.032%",
  x2: "50.032%",
  y1: "100.016%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "18%",
  stopColor: "#0052CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2684FF"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#trello_ico-a)",
  d: "M70,0 L10,0 C4.4771525,8.45347481e-16 1.48872085e-14,4.4771525 1.42108547e-14,10 L1.42108547e-14,70 C1.97924824e-14,75.5228475 4.4771525,80 10,80 L70,80 C75.5030136,79.9720656 79.9493095,75.5030845 79.9492386,70 L79.9492386,10 C79.9493095,4.49691549 75.5030136,0.0279344387 70,0 Z M34.7969543,60.5964467 C34.769128,63.2258866 32.6295871,65.3427868 30,65.3426396 L15.2284264,65.3426396 C12.5889549,65.3567526 10.433985,63.2358086 10.4060914,60.5964467 L10.4060914,60.5964467 L10.4060914,15.2030457 C10.4060735,13.9264046 10.914948,12.7024183 11.8200483,11.8020817 C12.7251486,10.9017451 13.9518032,10.3993367 15.2284264,10.4060914 L30,10.4060914 C32.6492847,10.4060914 34.7969543,12.553761 34.7969543,15.2030457 L34.7969543,60.5964467 Z M69.606599,40.5964467 C69.606599,43.2457314 67.4589294,45.393401 64.8096447,45.393401 L50,45.393401 C47.3507153,45.393401 45.2030457,43.2457314 45.2030457,40.5964467 L45.2030457,15.215736 C45.1996742,13.9413073 45.7035773,12.7179205 46.6035465,11.8155705 C47.5035156,10.9132205 48.7255668,10.4060869 50,10.4060914 L64.8096447,10.4060914 C67.4589294,10.4060914 69.606599,12.553761 69.606599,15.2030457 L69.606599,15.2030457 L69.606599,40.5964467 Z"
});

var SvgTrelloIco = function SvgTrelloIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrelloIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trello_ico.cef8bf29.svg";
export { ForwardRef as ReactComponent };